export default {
  "content": "<path d=\"M15.707 21.207c-.98.98-2.384 1.418-3.707 1.418s-2.727-.438-3.707-1.418l1.414-1.414c.52.52 1.366.832 2.293.832s1.773-.312 2.293-.832l1.414 1.414zM12 4a4.419 4.419 0 00-4.32 3.487L5.739 16.5h12.57c-.086-.49-.19-1.09-.294-1.71a100.94 100.94 0 01-.348-2.21c-.09-.637-.166-1.244-.166-1.58h2c0 .164.05.62.146 1.296.093.645.216 1.418.34 2.165.125.746.249 1.461.342 1.99l.113.634.032.175.008.046.002.011v.004A1 1 0 0119.5 18.5h-15a1.001 1.001 0 01-.978-1.21L5.726 7.065A6.419 6.419 0 0112 2v2z\" fill=\"#7B61FF\"/><path d=\"M19.146 2.01a1 1 0 01.597 1.659L16.745 7H20v2h-5.5a1 1 0 01-.743-1.669L16.755 4H14V2h5l.146.01z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};